/**This file is intended for keeping global constants which may or may not be used throught out the project. */
export const support_mail = "CostManagementPortal_Support@Genpt.com";

